<template>
  <div>
    <div class="consultDetail">
      <ConsultDetailBox :consult="currentConsult" :isMy="isMy" ></ConsultDetailBox>
      <div class="add" v-if="isMy && currentConsult.status<90">
        <textarea rows="3" v-model="replyContent"
          class="content"
          onfocus="if(value=='补充问题或回复'){value=''}"
          onblur="if (value ==''){value='补充问题或回复'}">
          补充问题或回复</textarea>
        <button class="play-button" @click="handleSubmit" v-preventReClick>提交</button>
      </div>
      <div class="conclusion" v-if="currentConsult.status ==90 || currentConsult.status ==100">
        <div class="star">
          <span class="star-label">整体评价</span>
          <table>
            <tr>
              <td v-for="(num,index) in currentConsult.starNum">
                <a class="rate-off rate-off2 rate-on rate-on2"></a>
              </td>
            </tr>
          </table>
        </div>
        <div class="resolve">
          <span class="resolve-label">问题是否解决</span>
          <span class="resolve-content" v-if="currentConsult.status==90">未解决</span>
          <span class="resolve-content" v-if="currentConsult.status==100">已解决</span>
        </div>
      </div>
    </div>
    <div class="bottom" v-if="isMy && currentConsult.status<90">
      <button class="play-button-half" @click="handleJudge">结束/评价</button>
      <button class="back-button-half" @click="emitBackConsult">返回咨询首页</button>
    </div>
    <div class="bottom" v-else>
      <button class="back-button-full" @click="emitBackConsult">返回咨询首页</button>
    </div>
    <div class="dialogWrapper" v-show="judgeModelVisible" >
      <div class="dialog">
        <div class="star">
          <span class="star-label">整体评价</span>
          <RateStar v-on:listenToChildEvent="getStar"></RateStar>
        </div>
        <div class="resolve">
          <span class="star-label">问题是否解决</span>
          <RateRadio :content="['未解决','已解决']" v-on:listenToChildEvent="checkResolved"></RateRadio>
        </div>
        <div class="buttonWrapper" >
          <button class="cancel-button" @click="handleModalCancel">取消</button>
          <button class="ok-button" @click="handleModalOk">确定</button>
        </div>
      </div>
    </div>
    <div class="v-modal-new" v-show="judgeModelVisible" ></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios';
import qs from 'qs';
import setWechatTitle from '@/utils/setWechatTitle.js'
import ConsultDetailBox from '@/components/consult/consultDetailBox.vue'
import RateStar from '@/components/RateStar.vue'
import RateRadio from '@/components/RateRadio.vue'
export default {
  name: 'ConsultDetail',
  props: {
    consult: {},
    isMy: Boolean,
  },
  components: {
    ConsultDetailBox,
    RateStar,
    RateRadio
  },

  data () {
    console.log('开始 consultDetail data() id：')
    return {
      replyContent: '',
      judgeModelVisible: false,
      star: 0,
      resolved: 0,
      currentConsult: this.consult
		}
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created(){
    setWechatTitle('咨询详情');
  },
  methods: {
    handleSubmit() {
      const options = {
        method: 'POST',
        headers: {'content-type': 'application/x-www-form-urlencoded'},
        data: qs.stringify({
          consultId: this.consult.id,
          reply: this.replyContent,
          openId: this.shengyaUser.openid
        }),
        url: '/cob/saveCosReply.do'
      };
      axios(options)
      .then( (res) => {
        if(res.data.result.success){
          let reply = res.data.data
          this.consult.replys.push(reply)
          this.replyContent = ''
        }
        else
          this.$store.commit('showMessage', {message: res.data.result.message,type: 'error'})
      })
      .catch(function (error) {
        console.warn(error);
      })
    },
    handleModalOk() {
      const options = {
        method: 'POST',
        headers: {'content-type': 'application/x-www-form-urlencoded'},
        data: qs.stringify({
          consultId: this.consult.id,
          isResolved:this.resolved,
          starNum:this.star,
          openId: this.shengyaUser.openid
        }),
        url: '/cob/judgeCosConsult.do'
      };
      axios(options)
      .then( (res) => {
        if(res.data.result.success){
          this.judgeModelVisible = false
          this.currentConsult = res.data.data
          this.$bus.$emit('judge-consult',this.currentConsult)
        }
        else
          this.$store.commit('showMessage', {message: res.data.result.message,type: 'error'})
      })
      .catch(function (error) {
        console.warn(error);
      })
    },
    handleJudge() {
      this.judgeModelVisible = true
    },
    handleModalCancel() {
      this.judgeModelVisible = false
    },
    //返回咨询
    emitBackConsult() {
      this.$emit('back-consult')
    },
    getStar(num){
      this.star = num
    },
    checkResolved(num){
      this.resolved = num
    }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.dialogWrapper
  z-index: 2002
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  .dialog
    margin-top: 15vh;
    margin-bottom: 50px;
    margin-left: auto
    margin-right: auto
    width: 80%;
    position: relative;
    background: #FFF;
    color: #777
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    .star
      padding: 0.62rem 0.44rem 0 0.44rem
      overflow:hidden;
      .star-label
        float:left;
        margin-top:0.1rem
    .resolve
      padding: 0.32rem 0.44rem 0 0.44rem
      overflow:hidden;
      .star-label
        float:left;
        margin-top:0.1rem
    .buttonWrapper
      padding: 0.36rem 0
      .cancel-button
        width: 37%
        height: 0.8rem
        margin-left: 0.6rem
        background: #787878
        color: #fff
      .ok-button
        width: 37%
        height: 0.8rem
        margin-left: 0.6rem
        background: #1798D3
        color: #fff
.v-modal-new
  z-index: 2001
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: .5;
  background: #000;

.consultDetail
  height :90vh
  overflow-x: auto;
.add
  margin: 0.24rem
  padding: 0.2rem 0.3rem 0.2rem 0.3rem
  background: #fff;
  border:1px #BBBBBB solid;
  .content
    font-size: 0.28rem
    border:1px #BBBBBB solid;
    width:100%
    margin: 0.06rem 0
    color:#999
    padding:0.1rem 0
    text-indent:0.2rem
 .play-button
    width: 100%
    height: 0.84rem
    margin-top: 0.24rem
    background: #FB8D3E
    color: #fff
.conclusion
  margin: 0.24rem
  padding: 0.2rem 0.3rem 0.2rem 0.3rem
  background: #fff;
  color: #777
  border:1px #BBBBBB solid;
  .star-label
    float:left;
    margin:0 1rem 0 0
  .resolve-label
    margin:0 0.5rem 0 0
  // .resolve-content
  //   color:#101010
  .rate-off
    width: 21px;
    height: 21px;
    text-decoration: none;
    border-radius: 30px;
    color: #333;
    border: 1px solid #cacece;
    cursor: default;
    display: inline-block;
    background: #fafafa;
    line-height: 19px;
    text-align: center;
  .rate-on
    background-color: #53a4f4 !important;
    border: 1px solid #53a4f4;
    position: relative;
    color: #fff;
  .rate-on2
    background: url(../images/wjxstar.png) !important;
    background-position: 0 -28px !important;
  .rate-off2
    background: url(../images/wjxstar.png);
    border-radius: 0;
    box-shadow: none;
    border: 0;
    padding: 2px;
.bottom
  padding: 0.24rem
  .back-button-full
    width: 100%
    height: 0.84rem
    background: #787878
    color: #fff
  .back-button-half
    width: 42%
    height: 0.84rem
    margin-left: 0.4rem
    background: #787878
    color: #fff
  .play-button-half
    width: 42%
    height: 0.84rem
    margin-left: 0.4rem
    background: #1798D3
    color: #fff

</style>
